import { useQuery } from 'react-query';

const DOCUMENT_BASE_URL = 'https://focus-docs.server.stablesoftware.com/files';

export const getDocumentUrl = (certNumber: string) =>
  `${DOCUMENT_BASE_URL}/${certNumber}.pdf`;

export function useDocumentAvailability(certNumber: string | null | undefined) {
  const { data: isAvailable, isLoading } = useQuery(
    ['document-availability', certNumber],
    async () => {
      if (!certNumber) return false;

      try {
        const response = await fetch(getDocumentUrl(certNumber), {
          method: 'HEAD',
        });

        return response.ok;
      } catch {
        return false;
      }
    },
    {
      enabled: !!certNumber,
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 30, // 30 minutes
      retry: false,
    }
  );

  return {
    isAvailable: isAvailable ?? false,
    isLoading: !!certNumber && isLoading,
    documentUrl: certNumber ? getDocumentUrl(certNumber) : null,
  };
}
